export const TOAST_TYPE = {
  NORMAL_TOAST: "NORMAL_TOAST",
  TOAST_WITH_CONTACT_PERSON: "TOAST_WITH_CONTACT_PERSON",
  TOAST_ADDITIONAL_CONTENT: "TOAST_ADDITIONAL_CONTENT",
  TOAST_CONTACT_ADDITIONAL_BELOW: "TOAST_CONTACT_ADDITIONAL_BELOW",
};
